'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _languageHandler = require('../../../languageHandler');

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2019 The Matrix.org Foundation C.I.C.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var IntegrationsImpossibleDialog = function (_React$Component) {
    (0, _inherits3.default)(IntegrationsImpossibleDialog, _React$Component);

    function IntegrationsImpossibleDialog() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, IntegrationsImpossibleDialog);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IntegrationsImpossibleDialog.__proto__ || (0, _getPrototypeOf2.default)(IntegrationsImpossibleDialog)).call.apply(_ref, [this].concat(args))), _this), _this._onAcknowledgeClick = function () {
            _this.props.onFinished();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(IntegrationsImpossibleDialog, [{
        key: 'render',
        value: function render() {
            var BaseDialog = _index2.default.getComponent('views.dialogs.BaseDialog');
            var DialogButtons = _index2.default.getComponent('views.elements.DialogButtons');

            return _react2.default.createElement(
                BaseDialog,
                { className: 'mx_IntegrationsImpossibleDialog', hasCancel: false,
                    onFinished: this.props.onFinished,
                    title: (0, _languageHandler._t)("Integrations not allowed") },
                _react2.default.createElement(
                    'div',
                    { className: 'mx_IntegrationsImpossibleDialog_content' },
                    _react2.default.createElement(
                        'p',
                        null,
                        (0, _languageHandler._t)("Your Riot doesn't allow you to use an Integration Manager to do this. " + "Please contact an admin.")
                    )
                ),
                _react2.default.createElement(DialogButtons, {
                    primaryButton: (0, _languageHandler._t)("OK"),
                    onPrimaryButtonClick: this._onAcknowledgeClick,
                    hasCancel: false
                })
            );
        }
    }]);
    return IntegrationsImpossibleDialog;
}(_react2.default.Component);

IntegrationsImpossibleDialog.propTypes = {
    onFinished: _propTypes2.default.func.isRequired
};
exports.default = IntegrationsImpossibleDialog;
module.exports = exports['default'];
//# sourceMappingURL=IntegrationsImpossibleDialog.js.map